import React from "react";
import {
	Card,
	CardContent,
	CardMedia,
	CssBaseline,
	Grid,
	Typography,
	Container,
	AppBar,
	Toolbar,
	Dialog,
	IconButton,
	Badge,
	SwipeableDrawer,
	useTheme,
	useMediaQuery,
	Accordion,
	AccordionSummary,
	AccordionDetails,
} from "@mui/material";
import { SelectChangeEvent } from "@mui/material/Select";
import Pagination from "@mui/material/Pagination";
import { useTranslation, Trans } from "react-i18next";
import ItemInfo from "./ItemInfo";
import Notifications from "../AlertMessage/Notifications";
import placeholder from "../../media/placeholder.png";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import Cart from "./Cart";
import { formatCurrency } from "../../utils/FormatCurrency";
import styles from "../../styles";
import Loader from "../../utils/Loader";
import Categories from "./Categories";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import acceptedCards from "../Profile/Payments/AcceptedCards";
const classes = {
	"@global": {
		ul: {
			margin: 0,
			padding: 0,
			listStyle: "none",
		},
	},
	appBar: {
		justifyContent: "space-between",
		display: "flex",
		top: 55,
		bottom: "auto",
		height: "58px",
		zIndex: 50,
	},
	toolbar: { alignContent: "center", height: 55 },
	grow: {
		flexGrow: 1,
	},
	link: {
		margin: "spacing(1, 1.5)",
	},
	cardHeader: {
		backgroundColor: "primary.main",
		color: "white",
	},
	cardPricing: {
		display: "flex",
		justifyContent: "center",
		alignItems: "baseline",
		marginBottom: 0,
	},
	storeContainer: {
		mb: 2,
		height: "100%",
		pt: { xs: 8, md: 4 },
		mt: { xs: 8, md: 8 },
		pb: { xs: 4, md: 0 },
		pl: { xs: 1, md: 8.5 },
		maxWidth: { xs: 370, sm: 557, md: 885, lg: 1150 },
	},
	media: {
		height: 200,
		width: "auto",
		padding: 0,
		display: "flex",
		marginLeft: "auto",
		marginRight: "auto",
		justifyContent: "center",
	},
	categories: {
		width: 260,
		display: "flex",
		marginLeft: "auto",
		marginRight: "auto",
		marginTop: { xs: 2.5, sm: 1.5 },
	},
	margin: {
		color: "white",
		marginLeft: { xs: 0, md: 5.5 },
	},

	mobileHidden: {
		justifyContent: "center",
		marginTop: 0.6,
		paddingLeft: { xs: 5.5, sm: 0 },
		display: { xs: "none", sm: "flex" },
	},
	desktopHidden: {
		display: { xs: "flex", sm: "none" },
		justifyContent: "center",
		marginTop: 0.6,
		paddingLeft: 2,
	},
	card: {
		maxHeight: 220,
		maxWidth: { lg: 245 },
		color: "#252525",
	},
	searchGrid: {
		pb: 3,
		ml: 2.5,
	},
	drawer: {
		marginTop: 110,
		zIndex: 1,
	},
	backdrop: {
		cursor: "pointer",
	},
	actionBar: {
		mt: { xs: 2, md: 1 },
		mb: { xs: 6 },
	},
};


export default function MarketPlace(props: any) {
	let items: any =
		[
			{
				"productId": "5",
				"quantity": 1,
				"isService": true,
				"isPackage": false,
				"categoryName": "Memberships",
				"name": "Fitness Class - Drop In",
				"description": "Get in shape with this great fitness class",
				"price": 29,
				"amount": 12.99,
				"productLegend": "",
				"imageUrl": "https://media.istockphoto.com/photos/every-step-taken-towards-fitness-pays-off-picture-id966295656?k=20&m=966295656&s=612x612&w=0&h=cYAqnyhO6E8x1SRCOjcBxWcOovPyWVAgFv1dTVl08sw="

			},
			{
				"productId": "6",
				"quantity": 1,
				"isService": true,
				"isPackage": false,
				"categoryName": "Private Training",
				"name": "Fitness Class - Renews for 2 more",
				"description": "",
				"price": 120,
				"amount": 120,
				"productLegend": "Automatic Renewal",
				"imageUrl": "https://media.istockphoto.com/photos/every-step-taken-towards-fitness-pays-off-picture-id966295656?k=20&m=966295656&s=612x612&w=0&h=cYAqnyhO6E8x1SRCOjcBxWcOovPyWVAgFv1dTVl08sw="
			},
			{
				"productId": "8",
				"quantity": 1,
				"isService": false,
				"isPackage": false,
				"categoryName": "Private Training",
				"name": "Kickboxing - 3 Sessions",
				"description": "",
				"price": 100,
				"amount": 100,
				"productLegend": "Automatic Renewal",
				"imageUrl": "https://media1.popsugar-assets.com/files/thumbor/jeF3H51zp4GzItvjYtR5ay3qJpU/fit-in/1024x1024/filters:format_auto-!!-:strip_icc-!!-/2018/11/07/977/n/1922729/7d3345045be366b75b61d9.75184836_/i/What-Know-Before-Your-First-Boxing-Class.jpg"
			},
			{
				"productId": "14",
				"quantity": 1,
				"isService": false,
				"isPackage": false,
				"categoryName": "Memberships",
				"name": "Kickboxing Class",
				"description": "Cardio kickboxing is a group fitness class that combines martial arts techniques with fast-paced cardio. This high-energy workout challenges the beginner and elite athlete alike. Build stamina, improve coordination and flexibility, and burn calories as you build lean muscle with this fun and challenging workout.Cardio kickboxing is a group fitness class that combines martial arts techniques with fast-paced cardio. This high-energy workout challenges the beginner and elite athlete alike. Build stamina, improve coordination and flexibility, and burn calories as you build lean muscle with this fun and challenging workout.Cardio kickboxing is a group fitness class that combines martial arts techniques with fast-paced cardio. This high-energy workout challenges the beginner and elite athlete alike. Build stamina, improve coordination and flexibility, and burn calories as you build lean muscle with this fun and challenging workout.Cardio kickboxing is a group fitness class that combines martial arts techniques with fast-paced cardio. This high-energy workout challenges the beginner and elite athlete alike. Build stamina, improve coordination and flexibility, and burn calories as you build lean muscle with this fun and challenging workout.Cardio kickboxing is a group fitness class that combines martial arts techniques with fast-paced cardio. This high-energy workout challenges the beginner and elite athlete alike. Build stamina, improve coordination and flexibility, and burn calories as you build lean muscle with this fun and challenging workout.Cardio kickboxing is a group fitness class that combines martial arts techniques with fast-paced cardio. This high-energy workout challenges the beginner and elite athlete alike. Build stamina, improve coordination and flexibility, and burn calories as you build lean muscle with this fun and challenging workout.Cardio kickboxing is a group fitness class that combines martial arts techniques with fast-paced cardio. This high-energy workout challenges the beginner and elite athlete alike. Build stamina, improve coordination and flexibility, and burn calories as you build lean muscle with this fun and challenging workout.dddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddd Bob",
				"price": 1005,
				"amount": 19.99,
				"productLegend": "Monthly Prorated",
				"imageUrl": "https://media1.popsugar-assets.com/files/thumbor/jeF3H51zp4GzItvjYtR5ay3qJpU/fit-in/1024x1024/filters:format_auto-!!-:strip_icc-!!-/2018/11/07/977/n/1922729/7d3345045be366b75b61d9.75184836_/i/What-Know-Before-Your-First-Boxing-Class.jpg"
			},
			{
				"productId": "16",
				"quantity": 1,
				"isService": false,
				"isPackage": false,
				"categoryName": "Memberships",
				"name": "Bodyfit - 6 Class Pass",
				"description": "",
				"price": 29,
				"amount": 129,
				"productLegend": "Monthly Prorated",
				"imageUrl": "https://gxunited.com/wp-content/uploads/2020/01/42.-Class-Intros-copy.jpg"
			},
			{
				"productId": "17",
				"quantity": 1,
				"isService": true,
				"isPackage": false,
				"categoryName": "Boxing Gloves",
				"name": "Body Sculpt - Drop In",
				"description": "",
				"price": 29,
				"amount": 12.99,
				"productLegend": "",
				"imageUrl": "https://3strong.com/wp-content/uploads/2019/02/4-Benefits-of-Joining-Group-Fitness-Classes.jpg"
			},
			{
				"productId": "31",
				"quantity": 1,
				"isService": true,
				"isPackage": false,
				"categoryName": "Memberships",
				"name": "Body Sculpt - 6 Classes",
				"description": "",
				"price": 0,
				"amount": 129.99,
				"productLegend": "",
				"imageUrl": "https://3strong.com/wp-content/uploads/2019/02/4-Benefits-of-Joining-Group-Fitness-Classes.jpg"

			},
			{
				"productId": "35",
				"quantity": 1,
				"isService": false,
				"isPackage": false,
				"categoryName": "T-Shirts",
				"name": "CrossFit Class",
				"description": "",
				"price": 25,
				"amount": 25,
				"productLegend": "",
				"imageUrl": "https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/solace-1525876940.jpg"

			},
			{
				"productId": "39",
				"quantity": 1,
				"isService": false,
				"isPackage": false,
				"categoryName": "T-Shirts",
				"name": "Womens Fitness Class",
				"description": "16:9",
				"price": 25,
				"amount": 25,
				"productLegend": "",
				"imageUrl": "https://blog.o2fitnessclubs.com/hs-fs/hubfs/DSCF0845-lighter%20bkgd.jpg?width=2048&name=DSCF0845-lighter%20bkgd.jpg"
			},

			{
				"productId": "50",
				"quantity": 1,
				"isService": false,
				"isPackage": false,
				"categoryName": "Hoodies",
				"name": "Body Fit - 6 Classes",
				"description": "",
				"price": 29,
				"amount": 129,
				"productLegend": "",
				"imageUrl": "https://gxunited.com/wp-content/uploads/2020/01/42.-Class-Intros-copy.jpg"
			},
			{
				"productId": "51",
				"quantity": 0,
				"isService": false,
				"isPackage": false,
				"categoryName": "Hoodies",
				"name": "Yoga - 1 Session",
				"description": "",
				"price": 29.99,
				"amount": 29.99,
				"productLegend": "",
				"imageUrl": "https://coac.swellclubs.com/wp-content/uploads/sites/3/2019/12/blog-yoga-for-every-body.jpg"
			},
			{
				"productId": "100",
				"quantity": 1,
				"isService": false,
				"isPackage": false,
				"categoryName": "Joel's Pantry",
				"name": "Yoga - 3 Sessions",
				"description": "Intro level Yoga class for beginners to intermediate.",
				"price": 89.99,
				"amount": 89.99,
				"productLegend": "",
				"imageUrl": "https://coac.swellclubs.com/wp-content/uploads/sites/3/2019/12/blog-yoga-for-every-body.jpg"
			},

		]
	const {
		purchaseSuccess,
		marketplace,
		cart,
		clubData,
	} = props;
	const [category, setCategory] = React.useState("All");
	const [messages, setMessages] = React.useState("")
	const [errors, setErrors] = React.useState("")
	const [open, setOpen] = React.useState(0);
	const [search, setSearch] = React.useState("");
	const [results, setResults] = React.useState<any>(items);
	const [filterDisplay, setFilterDisplay] = React.useState<any>([]);
	const [itemsPerPage] = React.useState(12);
	const [noOfPages, setNoOfPages] = React.useState(0);
	const [page, setPage] = React.useState(1);
	const [openCart, setOpenCart] = React.useState(false);
	const [cartItems, setCartItems] = React.useState([]);
	const [price, setPrice] = React.useState<number[]>([0, 1000]);
	const theme = useTheme();
	const toggleDrawer = (open: any) => {
		setOpenCart(open);
	};
	// let items: any = cart;
	const matches = useMediaQuery(theme.breakpoints.down("md"));

	const handlePageChange = (event: any, value: any) => {
		setPage(value);
	};
	const handleCategoryChange = (event: SelectChangeEvent) => {
		setCategory(event.target.value as string);
	};
	const handleSearch = (e: any) => {
		setSearch(e.target.value);
		let oldList: any = items?.map((item: any) => {
			return item.name.toLowerCase();
		});
		if (e.target.value !== "") {
			let newList: any = [];
			newList = oldList?.filter((item: any) => {
				return item.includes(e.target.value.toLowerCase());
			});
			setFilterDisplay(newList);
		} else {
			setFilterDisplay(items);
		}
	};
	const handleClick = (id: any) => {
		setOpen(id);
	};
	const handleClose = () => {
		setOpen(0);
	};
	useTranslation();

	const filterByCategory = (item: any) => {
		if (category === "All") {
			return item;
		} else {
			if (item.categoryName === category) {
				return item;
			}
		}
	};
	let searchResults = () => {
		let results: any = [];
		let filteredResults: any = items?.filter(filterByCategory);
		filteredResults?.map(
			(item: any) =>
				filterDisplay?.includes(item?.name?.toLowerCase()) && results.push(item)
		);
		return results;
	};
	React.useEffect(() => {
		let filteredResults: any = items?.filter(filterByCategory);
		if (price[1].toString() !== "1000") {
			filteredResults = filteredResults?.filter(
				(result: any) =>
					result.amount >= price[0] && result.amount <= price[1] && result
			);
		} else if (price[1].toString() === "1000") {
			filteredResults = filteredResults?.filter(
				(result: any) => result.amount >= price[0] && result
			);
		} else {
			setResults(filteredResults);
		}
		if (search?.length > 0) {
			let sResults: any = searchResults();
			if (price[1].toString() !== "1000") {
				sResults = sResults.filter(
					(result: any) =>
						result.amount >= price[0] && result.amount <= price[1] && result
				);
				setResults(sResults);
			} else if (price[1].toString() === "1000") {
				sResults = sResults.filter(
					(result: any) => result.amount >= price[0] && result
				);
				setResults(sResults);
			}
		} else {
			setResults(filteredResults);
		}
	}, [search, category, price]);

	React.useEffect(() => {
		let sortedMarketplace: any = items?.sort((a: any, b: any) => {
			if (a.name < b.name) {
				return -1;
			}
			if (a.name > b.name) {
				return 1;
			}
			return 0;
		});
		setResults(sortedMarketplace);
	}, []);

	React.useEffect(() => {
		let indexedCart: any = [];
		if (cart?.length > 1) {
			indexedCart = cart?.map((cartItem: any, index: any) => {
				if (cartItem) {
					cartItem.index = index;
					return cartItem;
				}
			});
		}
		setCartItems(indexedCart);
	}, [cart]);
	const defaultImage: any = placeholder;
	const clearMessages = () => {
		setMessages("")
		setErrors("")
	}
	const cartQuantity = () => {
		let quantity: any = 0;
		if (cartItems?.length > 0) {
			cartItems?.map((item: any) => {
				if (item && item?.quantity > 0) {
					quantity = quantity + item.quantity;
				}
			});
		}
		return quantity;
	};
	let cartCount = cartQuantity();
	React.useEffect(() => {
		cartCount = cartQuantity();
	}, [cartItems]);
	return (
		<div>
			<CssBaseline />
			{messages || errors ? (
				<Notifications
					messages={messages}
					errors={errors}
					clear={clearMessages}
					hide={false}
				/>
			) : null}
			<AppBar sx={classes.appBar} position="fixed">

				<Toolbar
					disableGutters={true}
					sx={{ ...classes.margin, minHeight: 55 }}
				>
					<Grid
						container
						justifyContent="space-between"
						alignContent="center"
						sx={{ height: 55 }}
					>
						<Grid item xs={4}>
							<Typography
								sx={classes.desktopHidden}
								component="h3"
								variant="h5"
								align="center"
							>
								<Trans>Marketplace</Trans>
							</Typography>
						</Grid>
						<Grid item xs={4}>
							<Typography
								sx={classes.mobileHidden}
								component="h3"
								variant="h5"
								align="center"
							>
								<Trans>Marketplace</Trans>
							</Typography>
						</Grid>
						<Grid item xs={4}>
							{cartItems ? (
								<div style={{ marginRight: 10, float: "right" }}>
									<IconButton onClick={() => toggleDrawer(true)} size="large">
										<Badge badgeContent={cartCount} color="error">
											<ShoppingCartIcon
												sx={{ color: "white", cursor: "pointer" }}
											/>
										</Badge>
									</IconButton>
								</div>
							) : null}
						</Grid>
					</Grid>
				</Toolbar>
			</AppBar>
			<React.Fragment>
				<SwipeableDrawer
					ModalProps={{
						BackdropProps: {
							sx: {
								root: classes.backdrop,
							},
						},
					}}
					PaperProps={{
						sx: { maxWidth: 445 },
					}}
					sx={{ paper: classes.drawer, maxWidth: 445 }}
					anchor={"right"}
					open={openCart}
					onClose={() => toggleDrawer(false)}
					onOpen={() => toggleDrawer(true)}
					children={
						<Cart
							{...props}
							cartItems={cartItems}
							setCartItems={setCartItems}
							defaultImage={defaultImage}
							setMessages={setMessages}
							handleClose={toggleDrawer}
						/>
					}
				/>
			</React.Fragment>
			<Container sx={classes.storeContainer} component="main">
				{matches ? (
					<Accordion
						sx={{
							boxShadow: "none",
							ml: 1.2,
							mb: 6,
							minHeight: 50,
							"&.Mui-expanded": {
								ml: 1.2,
								mb: 6,
							},
						}}
					>
						<AccordionSummary
							sx={{
								backgroundColor: "secondary.main",
								"&.Mui-expanded": {
									minHeight: 50,
									maxHeight: 50,
									borderRadius: 0,
								},
							}}
							expandIcon={<ExpandMoreIcon sx={{ color: "white" }} />}
						>
							<Typography sx={{ color: "white" }}>Filters</Typography>
						</AccordionSummary>
						<AccordionDetails sx={{ p: 0 }}>
							<Categories
								category={category}
								handleCategoryChange={handleCategoryChange}
								handleSearch={handleSearch}
								price={price}
								setPrice={setPrice}
								clubData={clubData}
								search={search}
								setSearch={setSearch}
							/>
						</AccordionDetails>
					</Accordion>
				) : (
					<div style={{ marginBottom: 50 }}>
						<Categories
							category={category}
							handleCategoryChange={handleCategoryChange}
							handleSearch={handleSearch}
							price={price}
							setPrice={setPrice}
							clubData={clubData}
							search={search}
							setSearch={setSearch}
						/>
					</div>
				)}

				<Grid
					container
					justifyContent="center"
					spacing={4}
					style={{ height: "100%" }}
				>
					<Grid
						container
						spacing={3}
						alignItems="flex-start"
						justifyContent="center"
						sx={classes.searchGrid}
					>
						{
							results
								?.slice((page - 1) * itemsPerPage, page * itemsPerPage)
								?.map((item: any, index: any) => (
									<React.Fragment key={index}>
										<Grid
											onClick={() => handleClick(item.productId)}
											item
											key={item.productId}
											xs={9}
											sm={6}
											md={4}
											lg={3}

										>
											<Card raised sx={classes.card}>
												<CardContent
													sx={{
														cursor: "pointer",
														position: "relative",
														padding: 0,
														backgroundColor: item.imageUrl ? "white" : "#E9EEF1",

													}}
												>
													<img src={item.imageUrl ? item.imageUrl : defaultImage} alt={item.name} style={{ height: 184, maxWidth: 245, padding: 0, display: "flex", marginLeft: "auto", marginRight: "auto", backgroundSize: "cover", justifyContent: "center" }}
													/>
													<div
														color="secondary"
														style={{
															position: "absolute",
															fontWeight: 600,
															fontSize: 16,
															top: 0,
															right: 0,
															color: theme.palette.secondary.main,
														}}
													>

														<Typography
															color="secondary"
															sx={{
																px: 0.4,
																margin: 1,
																fontWeight: 600,
																fontSize: 16,
																zIndex: 1,
																textAlign: "right",
																backgroundColor: "primary.main",
																borderRadius: 1.5
															}}
														>
															${item.amount.toFixed(2)}
														</Typography>

													</div>
													<div style={{ position: "absolute", top: 80, left: 0, right: 0 }}>
														{item.quantity === 0 && (
															<Typography
																align="center"
																variant="subtitle2"
																sx={{
																	mt: 0,
																	pt: 0.3,
																	color: "darkgray",
																	backgroundColor: "white",
																}}
															>
																OUT OF STOCK
															</Typography>
														)}
													</div>
												</CardContent>
												<Typography
													sx={{
														padding: 0.5,
														backgroundColor: "primary.main",
														color: "primary.contrastText"
													}}
													variant="subtitle1"
													align="center"
												>
													{item.name}
												</Typography>

											</Card>
											{results.length < 9 ? <Grid item /> : null}
										</Grid>
										<Dialog
											open={open === item.productId}
											onClose={handleClose}
											sx={styles.modal}
										>
											<ItemInfo
												{...props}
												messages={messages}
												errors={errors}
												setErrors={setErrors}
												setMessages={setMessages}
												cartItems={cartItems}
												setCartItems={setCartItems}
												item={item}
												defaultImage={defaultImage}
												additionalItems={item.additionalItems}
												acceptedCards={acceptedCards}
												handleClose={handleClose}
											/>
										</Dialog>
									</React.Fragment>
								))}

					</Grid>
					{noOfPages < 2 || results?.length === 0 ? null : (
						<div
							style={{
								padding: 1,
								paddingLeft: 45,
								paddingBottom: 20,
								paddingTop: 0,
								marginLeft: "auto",
								marginRight: "auto",
							}}
						>
							<Pagination
								showFirstButton
								showLastButton
								page={page}
								onChange={handlePageChange}
								count={noOfPages}
								color="secondary"
							/>
						</div>
					)}
				</Grid>
				{/* </Grow> */}
			</Container>
		</div>
	);
}
